import { render, staticRenderFns } from "./TheItemCloseModal.vue?vue&type=template&id=61e0d90e"
import script from "./TheItemCloseModal.vue?vue&type=script&lang=js"
export * from "./TheItemCloseModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports